import { makeObservable, observable, action, runInAction } from "mobx";

import { LabelValue } from "../models/Dashboard/Analytics";
import MockupsAnalyticsDashboardAPI from "../api/MockupsAnalyticsDashboardAPI";
import { MockupsAnalyticsAPIFilters } from "../models/Dashboard/OpsDashboard/MockupsAnalyticsFilters";

export class MockupsAnalyticsDashboardStore {
  analyticsAPI: MockupsAnalyticsDashboardAPI;
  basic_tats: LabelValue[];
  cdr_files_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new MockupsAnalyticsDashboardAPI();
    this.basic_tats = [];
    this.cdr_files_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      cdr_files_tats: observable,
      getMockupsAnalyticsTats: action,
      getCDRFilesAnalyticsTats: action,
    });
  }

  getMockupsAnalyticsTats = async (filters: MockupsAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getCDRFilesAnalyticsTats = async (filters: MockupsAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/cdr/tats",
        filters
      )) as LabelValue[];
      this.cdr_files_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
